import { MenuItemKey } from "../../Layout/Sidebar/MenuItemKey";
import ListRoles from "../../../Pages/Admin/Roles/List/ListRoles";
import ListUsers from "../../../Pages/Admin/Users/List/ListUsers";
import ListIdentityProviders from "../../../Pages/Admin/IdentityProviders/List/ListIdentityProviders";
import EditIdentityProvider from "../../../Pages/Admin/IdentityProviders/Edit/EditIdentityProvider";
import EditRole from "../../../Pages/Admin/Roles/Edit/EditRole";
import ListRegions from "../../../Pages/Admin/Regions/List/ListRegions";
import ListZones from "../../../Pages/Admin/Zones/List/ListZones";
import AdminListBuildings from "../../../Pages/Admin/Buildings/List/ListBuildings";
import EditSpace from "../../../Pages/Admin/Spaces/Edit/EditSpace";
import EditTaskCategory from "../../../Pages/Admin/TaskCategories/Edit/EditTaskCategory";
import EditTaskType from "../../../Pages/Admin/TaskTypes/Edit/EditTaskType";
import EditTaskState from "../../../Pages/Admin/TaskStates/Edit/EditTaskState";
import EditSpaceState from "../../../Pages/Admin/SpaceStates/Edit/EditSpaceState";
import EditUser from "../../../Pages/Admin/Users/Edit/EditUser";
import EditDevice from "../../../Pages/Admin/Devices/Edit/EditDevice";
import EditParameter from "../../../Pages/Admin/Parameters/Edit/EditParameter";
import EditBuildingKpis from "../../../Pages/Admin/BuildingKpis/Edit/EditBuildingKpis";
import ListFiles from "../../../Pages/Admin/Files/List/ListFiles";
import AdminListNotifications from "../../../Pages/Admin/Notifications/List/ListNotifications";
import EditNotification from "../../../Pages/Admin/Notifications/Edit/EditNotification";
import EditBookingPolicy from "../../../Pages/Admin/BookingPolicies/Edit/EditBookingPolicy";
import ListBookingPolicies from "../../../Pages/Admin/BookingPolicies/List/ListBookingPolicies";
import AssignBookingPolicyToSpace from "../../../Pages/Admin/BookingPolicies/AssignToSpace/AssignBookingPolicyToSpace";
import ListSpaces from "../../../Pages/Admin/Spaces/List/ListSpaces";
import EditAdvancedSpace from "../../../Pages/Admin/Spaces/EditAdvanced/EditAdvancedSpace.tsx";
import AdminCreateManyDelegates from "../../../Pages/Shared/Delegates/CreateMany/CreateManyDelegates";
import EditTags from "../../../Pages/Admin/Tags/Edit/EditTags";
import SystemFilters from "../../../Pages/Admin/SystemFilters/SystemFilters";
import ListNotificationReminders from "../../../Pages/Admin/NotificationReminders/List/ListNotificationReminders";
import EditNotificationReminders from "../../../Pages/Admin/NotificationReminders/Edit/EditNotificationReminders";
import ListCostCodes from "../../../Pages/Shared/CostCodes/List/ListCostCodes";
import { IRoute } from "./IbssRouter";
import EditBuilding from "../../../Pages/Admin/Buildings/Edit/EditBuilding";
import ListFloor from "../../../Pages/Admin/Floor/List/ListFloor";
import ListSignposts from "../../../Pages/Admin/Signposts/List/ListSignposts";
import VisitorTypes from "../../../Pages/Admin/VisitorTypes/ListAndEdit/VisitorTypes";
import ListStores from "../../../Pages/Admin/Equipments/Store/List/ListStores";
import AssignStoreToSpace from "../../../Pages/Admin/Equipments/Store/List/AssignStoreToSpace";
import ListEquipments from "../../../Pages/Admin/Equipments/Equipment/List/ListEquipments";
import { rights } from "../../../Common/RightsManager";

export default class AdminRoutes
{
    public routes: IRoute[] = [
        {
            isAuthorised: () => rights.ADMINPORTAL.Security.IdentityProviders.has(),
            path: "/security-identity-providers",
            component: ListIdentityProviders,
            menuItemId: MenuItemKey.Admin_Setup_Security_IdentityProviders
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.Security.IdentityProviders.has(),
            path: "/security-identity-providers/details",
            component: EditIdentityProvider,
            menuItemId: MenuItemKey.Admin_Setup_Security_IdentityProviders
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.Security.IdentityProviders.has(),
            path: "/security-identity-providers/details/:id",
            component: EditIdentityProvider,
            menuItemId: MenuItemKey.Admin_Setup_Security_IdentityProviders
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.Security.Users.has(),
            path: "/security-users/userdetails",
            component: EditUser,
            menuItemId: MenuItemKey.Admin_Manage_Users
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.Security.Roles.has(),
            path: "/security-roles/rolesdetails",
            component: EditRole,
            menuItemId: MenuItemKey.Admin_Setup_Security_Roles
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.Security.Users.has(),
            path: "/security-users/userdetails/:id",
            component: EditUser,
            menuItemId: MenuItemKey.Admin_Manage_Users
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.Security.Roles.has(),
            path: "/security-roles/rolesdetails/:id",
            component: EditRole,
            menuItemId: MenuItemKey.Admin_Setup_Security_Roles
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.Security.Roles.has(),
            path: "/security-roles",
            component: ListRoles,
            menuItemId: MenuItemKey.Admin_Setup_Security_Roles
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.Security.Delegates.has(),
            path: "/admin/delegates/create",
            component: AdminCreateManyDelegates,
            menuItemId: MenuItemKey.Admin_Setup_Security_DelegatePermissions
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.Security.Users.has(),
            path: "/security-users",
            component: ListUsers,
            menuItemId: MenuItemKey.Admin_Manage_Users
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.CostCodes.Read.has() || rights.ADMINPORTAL.Manage.CostCodes.has() || rights.API.CostCodes.V2.has(),
            path: "/admin/cost-codes",
            legacyPaths:[{path : "/cost-codes/"}],
            component: ListCostCodes,
            menuItemId: MenuItemKey.Admin_Manage_CostCodes
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/portfolio-setup-spaces/filter=Region",
            component: ListRegions,
            menuItemId: MenuItemKey.Admin_Setup_Organisation_Regions
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Buildings.has(),
            path: "/admin/buildings",
            component: AdminListBuildings,
            menuItemId: MenuItemKey.Admin_Setup_Organisation_Buildings
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Buildings.has(),
            path: "/admin/buildings/:buildingId/edit",
            component: EditBuilding,
            menuItemId: MenuItemKey.Admin_Setup_Organisation_Buildings
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Buildings.has(),
            path: "/admin/buildings/new",
            component: EditBuilding,
            menuItemId: MenuItemKey.Admin_Setup_Organisation_Buildings
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.BuildingKPIs.has(),
            path: '/admin/signposts/',
            component: ListSignposts,
            menuItemId: MenuItemKey.Admin_Manage_Signposts
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/portfolio-setup-spaces/filter=Zone",
            component: ListZones,
            menuItemId: MenuItemKey.NotSet
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/portfolio-setup-spaces/filter=Taskcategories/:id",
            component: EditTaskCategory
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.TaskCategories.has(),
            path: "/spaces-task-categories/filter=Taskcategories/:id",
            component: EditTaskCategory
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.TaskTypes.has(),
            path: "/spaces-task-types/filter=TaskTypes/:id",
            component: EditTaskType
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/portfolio-setup-spaces/filter=TaskTypes/:id",
            component: EditTaskType
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.TaskStates.has(),
            path: "/spaces-task-types/filter=TaskStates/:id",
            component: EditTaskState
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/portfolio-setup-spaces/filter=TaskStates/:id",
            component: EditTaskState
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/portfolio-setup-spaces/edit/:id/:filter(Region)",
            component: EditSpace,
            menuItemId: MenuItemKey.Admin_Setup_Organisation_Regions
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/portfolio-setup-spaces/edit/:id/:filter(Region)/:tab",
            component: EditSpace,
            menuItemId: MenuItemKey.Admin_Setup_Organisation_Regions
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/portfolio-setup-spaces/edit/:id/:filter(Building)",
            component: EditSpace,
            menuItemId: MenuItemKey.Admin_Setup_Organisation_Buildings
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/portfolio-setup-spaces/edit/:id/:filter(Building)/:tab",
            component: EditSpace,
            menuItemId: MenuItemKey.Admin_Setup_Organisation_Buildings
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.TaskStates.has(),
            path: "/spaces-task-types/filter=TaskStates/nodeid=:nodeid/id=:id",
            component: EditTaskState
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/portfolio-setup-spaces/filter=TaskStates/nodeid=:nodeid/id=:id",
            component: EditTaskState
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.TaskTypes.has(),
            path: "/spaces-task-types/filter=TaskTypes/nodeid=:nodeid/id=:id",
            component: EditTaskType
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/portfolio-setup-spaces/filter=Building/TaskTypes/nodeid=:nodeid/id=:id",
            component: EditTaskType
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.SpaceStates.has(),
            path: "/spaces-task-types/filter=SpaceStates/nodeid=:nodeid/id=:id",
            component: EditSpaceState
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/portfolio-setup-spaces/filter=SpaceStates/nodeid=:nodeid/id=:id",
            component: EditSpaceState
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.TaskCategories.has(),
            path: "/spaces-task-categories/filter=TaskCategories/nodeid=:nodeid/id=:id",
            component: EditTaskCategory
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/portfolio-setup-spaces/filter=TaskCategories/nodeid=:nodeid/id=:id",
            component: EditTaskCategory
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/portfolio-setup-spaces/filter=:filter/Device/nodeid=:nodeid/id=:id",
            component: EditDevice
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/portfolio-setup-spaces/filter=:filter/Parameter/nodeid=:nodeid/id=:id",
            component: EditParameter
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/portfolio-setup-spaces/filter=:filter/BuildingKPI/nodeid=:nodeid/id=:id",
            component: EditBuildingKpis
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.Manage.BookingPolicies.has() || rights.DATAMODEL.BookingPolicies.Read.has(),
            path: "/booking-policies/:buildingid",
            component: ListBookingPolicies,
            menuItemId: MenuItemKey.Admin_Manage_BookingPolicies
        },
        {
            isAuthorised: () => rights.DATAMODEL.BookingPolicies.Read.has(),
            path: "/booking-policies/assign/:bookingPolicyId",
            component: AssignBookingPolicyToSpace,
            menuItemId: MenuItemKey.Admin_Manage_BookingPolicies
        },
        {
            isAuthorised: () => rights.DATAMODEL.BookingPolicies.Read.has(),
            path: "/booking-policies/:buildingId/create",
            component: EditBookingPolicy,
            menuItemId: MenuItemKey.Admin_Manage_BookingPolicies
        },
        {
            isAuthorised: () => rights.DATAMODEL.BookingPolicies.Read.has(),
            path: "/booking-policies/edit/:policyId",
            component: EditBookingPolicy,
            menuItemId: MenuItemKey.Admin_Manage_BookingPolicies
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/floors/buildingId=:buildingId",
            component: ListFloor,
            menuItemId: MenuItemKey.Admin_Manage_Floor
        },
        {
            isAuthorised: () => rights.DATAMODEL.Filters.Read.has(),
            path: "/admin/system-filters/buildingId=:buildingid",
            component: SystemFilters,
            menuItemId: MenuItemKey.Admin_Manage_SystemFilters
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/admin/spaces",
            legacyPaths: [{ path: "/admin/buildings/:buildingid/spaces", parameterMap: { buildingid: "building" } }],
            component: ListSpaces,
            menuItemId: MenuItemKey.Admin_Manage_Spaces
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/admin/buildings/:floorid/spaces/:spaceid/edit",
            component: EditAdvancedSpace,
            menuItemId: MenuItemKey.Admin_Manage_Spaces
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Spaces.has(),
            path: "/admin/buildings/spaces/new",
            component: EditAdvancedSpace,
            menuItemId: MenuItemKey.Admin_Manage_Spaces
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.TagDefinitions.has(),
            path: "/admin/tags/new",
            component: EditTags,
            menuItemId: MenuItemKey.Admin_Manage_Tags
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Notifications.has(),
            path: "/notifications",
            component: AdminListNotifications,
            menuItemId: MenuItemKey.Admin_Setup_Organisation_Notifications
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.Notifications.has(),
            path: "/notifications/:notificationid",
            component: EditNotification,
            menuItemId: MenuItemKey.Admin_Setup_Organisation_Notifications
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.Files.Roamer.has(),
            path: "/filemgmt/roamer",
            component: ListFiles,
            menuItemId: MenuItemKey.Admin_Manage_FileManagement_Roamer
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.Files.Unity.has(),
            path: "/filemgmt/unity",
            component: ListFiles,
            menuItemId: MenuItemKey.Admin_Manage_FileManagement_Unity
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.Files.Inspire.has(),
            path: "/filemgmt/inspire",
            component: ListFiles,
            menuItemId: MenuItemKey.Admin_Manage_FileManagement_Inspire
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.Files.Common.has(),
            path: "/filemgmt/common",
            component: ListFiles,
            menuItemId: MenuItemKey.Admin_Manage_FileManagement_Common
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioManagement.NotificationReminders.has(),
            path: "/admin/notification-reminders/:buildingid",
            component: ListNotificationReminders,
            menuItemId: MenuItemKey.Admin_Manage_NotificationRecuring
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioManagement.NotificationReminders.has(),
            path: "/admin/notification-reminders/:buildingid/:reminderid/edit",
            component: EditNotificationReminders,
            menuItemId: MenuItemKey.Admin_Manage_NotificationRecuring
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioManagement.NotificationReminders.has(),
            path: "/admin/notification-reminders/:buildingid/new",
            component: EditNotificationReminders,
            menuItemId: MenuItemKey.Admin_Manage_NotificationRecuring
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioManagement.Equipment.has(),
            path: "/admin/equipments/",
            component: ListEquipments,
            menuItemId: MenuItemKey.Admin_Manage_Equipment_Items
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioSetup.VisitorTypes.has(),
            path: "/admin/visitor-types",
            component: VisitorTypes,
            menuItemId: MenuItemKey.Admin_Manage_VisitorTypes
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioManagement.Equipment.has(),
            path: "/admin/equipment/stores/",
            component: ListStores,
            menuItemId: MenuItemKey.Admin_Manage_Equipment_Stores
        },
        {
            isAuthorised: () => rights.ADMINPORTAL.PortfolioManagement.Equipment.has(),
            path: "/admin/store/assign/:storeid",
            component: AssignStoreToSpace,
            menuItemId: MenuItemKey.Admin_Manage_Equipment_Stores
        },
    ];
}
